// /CoreWrapper/cores/coreBorderColorOrGradient.js
/* eslint-disable react/prop-types */
import React from 'react'

const toArray = (v) => (Array.isArray(v) ? v : v ? [v] : [])

export function coreBorderColorOrGradient(BaseComponent) {
	const WithBorder = ({
		borderColors, // string | string[]
		borderColorsHover, // string | string[]
		animate, // bool, optional
		borderWidth, // number | string (controls ring thickness / border width)
		borderDegree = 120, // gradient angle
		className = '',
		style = {},
		...rest
	}) => {
		const colors = toArray(borderColors)

		// No border config → no feature
		if (!colors.length) {
			return (
				<BaseComponent className={className} style={style} {...rest} />
			)
		}

		const hoverColors = toArray(borderColorsHover)

		const isMulti = colors.length > 1
		const isAnimated = animate !== undefined ? animate : isMulti
		const isStaticGradient = isMulti && !isAnimated

		const baseColor = colors[0]
		const angle = borderDegree + 'deg'
		const baseGradient = `linear-gradient(${angle}, ${colors.join(',')})`

		const hoverColor = hoverColors[0] || baseColor
		const hoverGradient = hoverColors.length
			? `linear-gradient(${angle}, ${hoverColors.join(',')})`
			: baseGradient

		const modeClass = isAnimated
			? 'wbk-border-animated'
			: isStaticGradient
			? 'wbk-border-static-gradient'
			: 'wbk-border-static'

		let ringWidth
		if (borderWidth !== undefined) {
			ringWidth =
				typeof borderWidth === 'number'
					? `${borderWidth}px`
					: borderWidth
		}

		const mergedClassName = ['wbk-border', modeClass, className]
			.filter(Boolean)
			.join(' ')

		const mergedStyle = {
			'--wbk-border-color': baseColor,
			'--wbk-border-color-hover': hoverColor,
			'--wbk-border-gradient': baseGradient,
			'--wbk-border-gradient-hover': hoverGradient,
			...(ringWidth ? { '--wbk-border-width': ringWidth } : {}),
			...style
		}

		return (
			<BaseComponent
				className={mergedClassName}
				style={mergedStyle}
				{...rest}
			/>
		)
	}

	return WithBorder
}
